import lottie from 'lottie-web';
import {TweenMax} from 'gsap';

export default class BasicForm {
    constructor() {
        this.personInput = document.querySelector('#person');
        this.msgTypeInput = document.querySelector('#msgType');
        const wpcf7Elm = document.querySelector('.wpcf7');

        if (!wpcf7Elm) {
            return;
        }

        let submitBtn = document.querySelector('.wpcf7-submit');

        submitBtn.addEventListener('click', (ev) => {
            if (submitBtn.classList.contains('is-clicked')) {
                ev.preventDefault();
                return;
            }

            submitBtn.classList.add('is-clicked');
        });

        wpcf7Elm.addEventListener('wpcf7submit', (event) => {

            if (event.detail.status === 'validation_failed') {
                submitBtn.classList.remove('is-clicked');
            }
        });

        wpcf7Elm.addEventListener('wpcf7mailsent', (event) => {
            this.afterFormSuccessSubmit(event);
            let person = document.querySelector(`[data-person-index="${this.personInput.value}"]`);
            let msg = document.querySelector(`[data-msg-type-index="${this.msgTypeInput.value}"]`);
            let label = `${msg.dataset.msgType} - ${person.dataset.fullName}`;

            this.sendDataLayer('savjet', 'uspješno-poslano', label);
        }, false);

        this.counter();
        this.hoverState();
    }

    showThankYouStep(influencerId, visibility) {

        const thankYouStep = document.querySelector('.js-step.js-thank-you');

        if (!thankYouStep) {
            return;
        }

        const thankYouVisibilityMsg = thankYouStep.querySelector('.js-thank-you-visibility');
        const thankYouInfluencerMsg = thankYouStep.querySelector('.js-thank-you-influencer-message');
        const thankYouInfluencerName = thankYouStep.querySelector('.js-thank-you-influencer-name');

        const influencerField = document.querySelector('[data-person-index="' + influencerId + '"]');
        const visibilityField = document.querySelector('[data-msg-type-index="' + visibility + '"]');

        thankYouInfluencerMsg.innerText = influencerField.dataset.thankYou;
        thankYouInfluencerName.innerText = influencerField.dataset.fullName;
        thankYouVisibilityMsg.innerText = visibilityField.dataset.thankYou;

        thankYouStep.classList.add('is-active');
    }

    getValueFromInputs(inputs, name) {
        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].name === name) {
                return inputs[i].value;
            }
        }

        return false;
    }

    afterFormSuccessSubmit(event) {
        const inputs = event.detail.inputs;

        const influencerId = this.getValueFromInputs(inputs, 'influencer');
        const visibility = this.getValueFromInputs(inputs, 'visibility');

        if (!influencerId || !visibility) {
            return;
        }

        this.lottieController();

        this.showThankYouStep(influencerId, visibility);

        document.querySelector('.js-step.is-active').classList.remove('is-active');
        document.querySelector('.js-step-indicator.is-active').classList.add('is-finished');
    }

    lottieController() {
        console.log(window.lottiePath);
        const lottieContainer = document.querySelector('.js-lottie-container');
        let lott = lottie.loadAnimation({
            container: lottieContainer,
            renderer: 'svg',
            loop: 1,
            autoplay: true,
            path: window.lottiePath
        });

        lott.addEventListener('complete', () => {
            TweenMax.to(lottieContainer, 0.3, {
                autoAlpha: 0
            })
        })
    }

    sendDataLayer(category, action, label) {
        dataLayer.push({
            event: '_d_GAEvent',
            eventCategory: category,
            eventAction: action,
            eventLabel: label
        });
    }

    counter() {
        let textarea = document.querySelector('#subject');

        if (!textarea) {
            return;
        }

        let counter = document.querySelector('.js-counter');

        textarea.addEventListener('keyup', (ev) => {

            counter.innerHTML = ev.currentTarget.value.length;
        });
    }

    hoverState() {
        let text = document.querySelectorAll('.wpcf7-text');
        let textArea = document.querySelectorAll('.wpcf7-textarea');
        let number = document.querySelectorAll('.wpcf7-number');

        if (text.length > 0) {
            for (let textItem of text) {
                this.isBlurred(textItem);
                this.isFocused(textItem);
            }
        }

        if (textArea.length > 0) {
            for (let textAreaItem of textArea) {
                this.isBlurred(textAreaItem);
                this.isFocused(textAreaItem);
            }
        }

        if (number.length > 0) {
            for (let numberItem of number) {
                this.isBlurred(numberItem);
                this.isFocused(numberItem);
            }
        }
    }

    isFocused(item) {
        item.addEventListener('focus', () => {
            item.parentElement.classList.add('is-focused');
        })
    }

    isBlurred(item) {
        item.addEventListener('blur', () => {
            item.parentElement.classList.remove('is-focused');
        })
    }
}
